



<div style="text-align: center;">
  <br>
  <img [src]="avatar" alt="profile photo" width="200" height="200" style="object-fit: cover;">
  <input #clickUpload type="file" accept=".jpg,.jpeg" style="display: none"
         id="file"  mat-flat-button mat-button color="primary"
         (change)="handleFileInput($event)">
  <span style="font-size: 10px;"><br>Accept only JPEG format for avatar.<br></span>
    <button  (click)="upload()" [disabled]="files == null"  mat-flat-button mat-button color="primary"  style="color:{{con.theme.buttonText}}; background-color: {{con.theme.buttonBackground}};" >Upload</button>
</div>

<section class="recovery-email-settings">
  <h3>Recovery email</h3>
  <p *ngIf="!emailSupportChecked">Checking email recovery support...</p>
  <p *ngIf="emailSupportChecked && !emailSupportAvailable">Email recovery is unavailable on this server. SMS sign-in is still available.</p>
  <p *ngIf="emailSupportAvailable && recoveryEmailLoading">Checking recovery email status...</p>
  <div *ngIf="emailSupportAvailable && !recoveryEmailLoading && recoveryEmailMask">
    <p>Verified recovery email: <strong>{{recoveryEmailMask}}</strong></p>
  </div>
  <div *ngIf="emailSupportAvailable && !recoveryEmailLoading && !recoveryEmailMask && !showRecoveryEmailForm">
    <p>No verified recovery email is linked to this account.</p>
    <button mat-flat-button color="primary" type="button" (click)="showAddRecoveryEmail()">Add recovery email</button>
  </div>
  <app-email-verification *ngIf="emailSupportAvailable && showRecoveryEmailForm" (verified)="recoveryEmailVerified()"
                          (cancel)="cancelRecoveryEmail()">
  </app-email-verification>
</section>




    <form [formGroup]="nickForm">
      <mat-form-field appearance="standard" style="padding: 20px 0px 0px 20px">
        <mat-label>Nickname</mat-label>
        <input matInput #input [autofocus]="true" [formControl]="nick" (keydown)="nickChanged = true" minlength="3" maxlength="128" >
      </mat-form-field>
      <button (click)="updateNickSave()" [disabled]="!nickChanged" mat-flat-button mat-button color="primary"  style="color:{{con.theme.buttonText}}; background-color: {{con.theme.buttonBackground}};" >Save</button>
    </form>


